export default __webpack_public_path__ + "media/assets/img/icon_img-1474f646de694c00b50946950e97a211.png";